import { Link } from "react-router-dom";
import { ArrowRight, Mail, Phone } from "lucide-react";
import { COMPANY } from "@/data/company";

// Full-width closing call-to-action banner, reused across pages.
export default function PageLinkCTA() {
  return (
    <div className="relative overflow-hidden rounded-3xl border border-brand-emerald/25 bg-gradient-to-br from-white via-[#EAF1F8] to-white p-10 text-center shadow-[0_30px_80px_rgba(16,185,129,0.12)] md:p-14" data-testid="cta-banner">
      <div className="absolute inset-0 blueprint-grid opacity-70" aria-hidden="true" />
      <div className="relative">
        <h2 className="font-display text-3xl font-extrabold uppercase tracking-tight text-ink sm:text-4xl">
          Have a Railway Engineering <span className="accent-text">Requirement?</span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-slate-500">
          Share your product or project requirement — our team will respond with a considered, engineering-first
          reply.
        </p>
        <div className="mt-9 flex flex-wrap justify-center gap-4">
          <Link to="/contact" data-testid="cta-enquire-button" className="btn btn-primary">
            Enquire Now
            <ArrowRight className="h-4 w-4" />
          </Link>
          <a href={`tel:${COMPANY.phones[0].link}`} className="btn btn-outline" data-testid="cta-call-button">
            <Phone className="h-4 w-4" />
            {COMPANY.phones[0].display}
          </a>
          <a href={`mailto:${COMPANY.emails[1]}`} className="btn btn-outline" data-testid="cta-email-button">
            <Mail className="h-4 w-4" />
            Email Us
          </a>
        </div>
      </div>
    </div>
  );
}
